<template>
  <div>
    <h1 class="thank-you-text">Your request is being processed...</h1>
    <loading :active.sync="isLoading"
             :is-full-page="fullPage"/>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'Process',

  components: {
    Loading
  },

  data () {
    return {
      isLoading: false,
      fullPage: true,
      interval: null,
      counter: 0,
      container: null,
      containerId: null,
      isIntro: false
    }
  },

  mounted () {
    let queryParams = this.$route.query
    let operation = ''

    if (!queryParams.type || !queryParams.op) {
      this.$events.$emit('alert', {
        header: this.$t('globals.validation.errors.error'),
        message: 'Something went wrong',
        type: 'error',
        align: 'right'
      })

      setTimeout(() => {
        this.$router.push('/dashboard')
      }, 3000)
    } else {
      this.container = queryParams.type
      this.containerId = queryParams.id
      this.isIntro = queryParams.intro

      operation = queryParams.op
    }

    this.isLoading = true

    if (operation === 'agreement_status') {
      const self = this

      this.interval = setInterval(function () {
        self.counter++
        self.checkVippsAgreementStatus()

        if (self.counter > 3) {
          self.counter = 0
          clearInterval(self.interval)

          self.$events.$emit('alert', {
            header: self.$t('globals.validation.errors.error'),
            message: 'Something went wrong',
            type: 'error',
            align: 'right'
          })

          self.redirectToFailedPage()
        }
      }, 5000)
    }

    if (operation === 'payment_status') {
      const self = this

      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local') {
        this.interval = setInterval(function () {
          self.counter++
          self.checkVippsPaymentStatus()

          if (self.counter > 20) {
            self.counter = 0
            clearInterval(self.interval)

            self.redirectToFailedPage()
          }
        }, 3000)
      } else {
        this.interval = setInterval(function () {
          self.counter++
          self.checkVippsPaymentStatus()

          if (self.counter > 10) {
            self.counter = 0
            clearInterval(self.interval)

            self.$events.$emit('alert', {
              header: self.$t('globals.validation.errors.error'),
              message: 'Something went wrong',
              type: 'error',
              align: 'right'
            })

            self.redirectToFailedPage()
          }
        }, 3000)
      }
    }

    if (operation === 'startup_fee_status') {
      // this is for Vipps payment
      const self = this

      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local') {
        this.interval = setInterval(function () {
          self.counter++
          self.checkStartupFeeCompleted()

          if (self.counter > 100) {
            self.counter = 0
            clearInterval(self.interval)

            self.$events.$emit('alert', {
              header: self.$t('globals.validation.errors.error'),
              message: self.$t('globals.validation.errors.startup_fee_payment_not_completed'),
              type: 'error',
              align: 'right'
            })

            if (self.container === 'booked') {
              self.$router.push({name: 'bookings'})
            } else {
              self.redirect()
            }
          }
        }, 3000)
      } else {
        this.interval = setInterval(function () {
          self.counter++
          self.checkStartupFeeCompleted()

          if (self.counter > 3) {
            self.counter = 0
            clearInterval(self.interval)

            self.$events.$emit('alert', {
              header: self.$t('globals.validation.errors.error'),
              message: self.$t('globals.validation.errors.startup_fee_payment_not_completed'),
              type: 'error',
              align: 'right'
            })

            if (self.container === 'booked') {
              self.$router.push({name: 'bookings'})
            } else {
              self.redirect()
            }
          }
        }, 3000)
      }
    }

    if (operation === 'overdue_fee_status') {
      const self = this

      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local') {
        this.interval = setInterval(function () {
          self.counter++
          self.checkVippsPaymentStatus(true)

          if (self.counter > 100) {
            self.counter = 0
            clearInterval(self.interval)

            self.$events.$emit('alert', {
              header: self.$t('globals.validation.errors.error'),
              message: 'Something went wrong',
              type: 'error',
              align: 'right'
            })

            if (self.container === 'booked') {
              self.$router.push({name: 'bookings'})
            } else {
              self.redirect()
            }
          }
        }, 3000)
      } else {
        this.interval = setInterval(function () {
          self.counter++
          self.checkVippsPaymentStatus(true)

          if (self.counter > 3) {
            self.counter = 0
            clearInterval(self.interval)

            self.$events.$emit('alert', {
              header: self.$t('globals.validation.errors.error'),
              message: 'Something went wrong',
              type: 'error',
              align: 'right'
            })

            if (self.container === 'booked') {
              self.$router.push({name: 'bookings'})
            } else {
              self.redirect()
            }
          }
        }, 3000)
      }
    }
  },

  methods: {
    checkVippsAgreementStatus () {
      this.axios.get(`/${this.container}/${this.containerId}/vipps/agreement`).then(({data}) => {
        if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local') {
          this.axios.put(`/vipps/agreements/${data.id}`, {'status': data.status}).then(() => {
            this.processVippsAgreementStatus(data.status, true)
          }).catch(() => {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.something_went_wrong'),
              message: this.$t('globals.validation.errors.try_again_later'),
              type: 'error',
              align: 'right'
            })

            this.failRedirect()
          })
        } else {
          this.processVippsAgreementStatus(data.status)
        }
      })
    },

    processVippsAgreementStatus (status, isLocal = false) {
      if (status === 'ACTIVE') {
        if (isLocal) {
          this.axios.put(`/${this.container}/${this.containerId}/activate`).then((response) => {
            if (response.status === 202 || this.container === 'booked') {
              clearInterval(this.interval)

              this.$events.$emit('alert', {
                header: this.$t('globals.validation.success.success'),
                message: this.getAgreementActivatedMessage(),
                type: 'success',
                align: 'right'
              })

              this.redirectToSuccessPage(3000)
            }
          })
        } else {
          clearInterval(this.interval)

          const message = this.getAgreementActivatedMessage()

          this.$events.$emit('alert', {
            header: this.$t('globals.validation.success.success'),
            message: message,
            type: 'success',
            align: 'right'
          })

          this.redirectToSuccessPage(3000)
        }
      } else if (status === 'EXPIRED') {
        clearInterval(this.interval)

        this.$events.$emit('alert', {
          header: this.$t('globals.validation.errors.error'),
          message: 'Agreement expired',
          type: 'error',
          align: 'right'
        })

        this.failRedirect()
      } else if (status === 'STOPPED') {
        clearInterval(this.interval)

        this.$events.$emit('alert', {
          header: this.$t('globals.validation.errors.error'),
          message: 'Agreement stopped',
          type: 'error',
          align: 'right'
        })

        this.failRedirect()
      }
    },

    getAgreementActivatedMessage () {
      if (this.container === 'subscriptions') {
        return this.$t('modals.newsubscriptionmodal.validation.nets.success.subscription_added')
      }

      if (this.container === 'booked') {
        this.$events.$emit('booking-reserved', this.containerId)

        return this.$t('pages.bookings.validation.success.booking_agreement_confirmed')
      }

      return this.$t('modals.newwaitlistmodal.validation.success.waitlist_added')
    },

    checkVippsPaymentStatus (overdueFee = false) {
      let config = {}

      if (overdueFee) {
        config['params'] = {
          overdue_fee: true
        }
      }

      this.axios.get(`/${this.container}/${this.containerId}/vipps/payment`, config).then(({data}) => {
        if (data.metadata.overdue) {
          console.log('Checking overdue payment status')
        }

        if (data.state === 'AUTHORIZED') {
          clearInterval(this.interval)

          if (overdueFee) {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.success.success'),
              message: this.$t('globals.validation.success.overdue_fee_payment_successful'),
              type: 'success',
              align: 'right'
            })

            setTimeout(() => {
              this.redirect()
            }, 3000)
          } else if (data.metadata.overdue) {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.success.success'),
              message: this.$t('globals.validation.success.overdue_payment_successful'),
              type: 'success',
              align: 'right'
            })

            setTimeout(() => {
              this.redirect()
            }, 3000)
          } else {
            if (this.container === 'booked') {
              this.$events.$emit('booking-reserved', this.containerId)

              this.$events.$emit('alert', {
                header: this.$t('globals.validation.success.success'),
                message: this.$t('pages.bookings.validation.success.booking_paid'),
                type: 'success',
                align: 'right'
              })

              this.redirectToSuccessPage(3000)
            } else {
              let message
              if (this.container === 'subscriptions') {
                message = this.$t('modals.newsubscriptionmodal.validation.nets.success.subscription_added')
              } else {
                message = this.$t('modals.newwaitlistmodal.validation.success.waitlist_added')
              }

              this.$events.$emit('alert', {
                header: this.$t('globals.validation.success.success'),
                message: message,
                type: 'success',
                align: 'right'
              })

              this.redirectToSuccessPage(3000)
            }
          }
        } else if (data.state === 'ABORTED') {
          clearInterval(this.interval)
          this.$events.$emit('alert', {
            header: this.$t('globals.validation.errors.error'),
            message: this.$t('globals.validation.errors.payment_failed'),
            type: 'error',
            align: 'right'
          })

          this.failRedirect()
        } else if (data.state === 'EXPIRED') {
          clearInterval(this.interval)

          this.$events.$emit('alert', {
            header: this.$t('globals.validation.errors.error'),
            message: this.$t('globals.validation.errors.payment_failed'),
            type: 'error',
            align: 'right'
          })

          this.failRedirect()
        } else if (data.state === 'TERMINATED' || data.state === 'CANCELLED') {
          clearInterval(this.interval)

          this.$events.$emit('alert', {
            header: this.$t('globals.validation.errors.error'),
            message: 'Payment has been terminated',
            type: 'error',
            align: 'right'
          })

          this.failRedirect()
        }
      }).catch(() => {
        this.$events.$emit('alert', {
          header: this.$t('globals.validation.errors.something_went_wrong'),
          message: this.$t('globals.validation.errors.try_again_later'),
          type: 'error',
          align: 'right'
        })

        this.failRedirect()
      })
    },

    checkStartupFeeCompleted () {
      this.axios.get(`/booked/${this.containerId}`)
        .then(({data}) => {
          let booked = data.data

          if (booked.status === 'unset') {
            clearInterval(this.interval)

            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.error'),
              message: this.$t('globals.validation.errors.startup_fee_payment_not_completed'),
              type: 'error',
              align: 'right'
            })

            setTimeout(() => {
              this.$router.push({name: 'bookings'})
            }, 3000)
          } else if (booked.startup_fee === 'completed') {
            clearInterval(this.interval)

            this.$events.$emit('alert', {
              header: this.$t('globals.validation.success.success'),
              message: this.$t('globals.validation.success.startup_fee_payment_successful'),
              type: 'success',
              align: 'right'
            })

            if (!data.data.is_free) {
              setTimeout(() => {
                this.createVippsPayment(this.containerId)
              }, 3000)
            } else {
              setTimeout(() => {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.success.success'),
                  message: this.$t('pages.bookings.validation.success.booking_added_free'),
                  type: 'success',
                  align: 'right'
                })

                this.$router.push({name: 'bookings'})
              }, 3000)
            }
          }
        })
    },

    createVippsPayment (bookedId) {
      this.axios.post(`booked/${bookedId}/createPayment`).then((response) => {
        if (response.data.url) {
          window.location.href = response.data.url
        }
      }).catch((error) => {
        if (error.response) {
          if (error.response.data.message) {
            let errorDescription = JSON.parse(error.response.data.message)
            let messageText

            if (errorDescription.hasOwnProperty('error_description')) {
              messageText = errorDescription.error_description.message
            } else if (errorDescription.hasOwnProperty('message')) {
              messageText = errorDescription.message
            } else {
              messageText = this.$t('globals.validation.errors.try_again_later')
            }

            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.error'),
              message: messageText,
              type: 'error',
              align: 'right'
            })
          } else {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.something_went_wrong'),
              message: this.$t('globals.validation.errors.try_again_later'),
              type: 'error',
              align: 'right'
            })
          }
        } else {
          this.$events.$emit('alert', {
            header: this.$t('globals.validation.errors.something_went_wrong'),
            message: this.$t('globals.validation.errors.try_again_later'),
            type: 'error',
            align: 'right'
          })
        }
      })
    },

    redirectToSuccessPage (timeout = 1500) {
      let query = {
        container: this.container,
        containerId: this.containerId,
      }

      if (this.isIntro) {
        query['intro'] = true
      }

      this.selfRedirect = true
      setTimeout(() => {
        this.$router.push({
          name: 'vipps_success',
          query: query
        })
      }, timeout)
    },

    redirectToFailedPage(timeout = 1500) {
      let query = {
        container: this.container,
        containerId: this.containerId,
      }

      this.selfRedirect = true
      setTimeout(() => {
        this.$router.push({
          name: 'vipps_failed',
          query: query
        })
      }, timeout)
    },

    redirect () {
      this.isLoading = false
      if (this.container === 'subscriptions') {
        this.$router.push({name: 'subscriptiondashboard', params: { subscriptionId: this.containerId }},
          () => {
            this.$router.go()
          }
        )
      } else {
        this.$router.push({name: 'wait_list'},
          () => {
            this.$router.go()
          }
        )
      }
    },

    failRedirect () {
      if (this.container === 'subscriptions') {
        setTimeout(() => {
          this.$router.push({name: 'dashboard'}, () => {
            this.$router.go()
          })
        }, 3000)
      } else if (this.container === 'booked') {
        setTimeout(() => {
          this.$router.push({name: 'bookings'})
        }, 3000)
      } else {
        setTimeout(() => {
          this.$router.push({name: 'wait_list'},
            () => {
              this.$router.go()
            }
          )
        }, 3000)
      }
    }
  }
}
</script>

<style scoped>
.thank-you-text {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/payment/vipps/Process.vue